export const INIT_DAILY_REPORT_REQUEST = 'INIT_DAILY_REPORT_REQUEST';
export const SET_DAILY_REPORT = 'SET_DAILY_REPORT';
export const ERROR_DAILY_REPORT = 'ERROR_DAILY_REPORT';
export const INIT_YEARLY_REPORT_REQUEST = 'INIT_YEARLY_REPORT_REQUEST';
export const SET_YEARLY_REPORT = 'SET_YEARLY_REPORT';
export const ERROR_YEARLY_REPORT = 'ERROR_YEARLY_REPORT';

export const initDailyReportRequest = () => ({ type: INIT_DAILY_REPORT_REQUEST });
export const setDailyReport = (payload) => ({ type: SET_DAILY_REPORT, payload });
export const errorDailyReport = (payload) => ({ type: ERROR_DAILY_REPORT, payload });
export const initYearlyReportRequest = () => ({ type: INIT_YEARLY_REPORT_REQUEST });
export const setYearlyReport = (payload) => ({ type: SET_YEARLY_REPORT, payload });
export const errorYearlyReport = (payload) => ({ type: ERROR_YEARLY_REPORT, payload });
